import { getWindow } from "../getWindow"

/**
 * Makes screen reader to speak the given text outloud with the specified priority.
 * @param {string} text Given text to be spoken.
 * @param {'polite'|'assertive'} priority Priority of the spoken text. Defaults to "polite".
 */
export function screenReaderSpeak(text, priority) {
  const ssrWindow = getWindow()
  const el = ssrWindow.document.createElement("div")
  const id = `speak-${Date.now()}`
  el.setAttribute("id", id)
  el.setAttribute("aria-live", priority || "polite")
  el.setAttribute("aria-atomic", "true")
  el.classList.add("visually-hidden")
  el.style.cssText = `
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  `
  ssrWindow.document.body.appendChild(el)

  setTimeout(() => {
    ssrWindow.document.getElementById(id).innerHTML = text
  }, 100)

  setTimeout(() => {
    ssrWindow.document.body.removeChild(ssrWindow.document.getElementById(id))
  }, 1000)
}
